
import {
  toast as sonnerToast,
  ToastT,
  Toaster,
  type ToasterProps,
} from "sonner";

export interface ToastProps {
  title?: string;
  description?: string;
  variant?: "default" | "destructive";
  duration?: number;
}

export function toast({
  title,
  description,
  variant = "default",
  duration = 5000,
  ...props
}: ToastProps) {
  return sonnerToast(title || description || "", {
    description: title ? description : undefined,
    duration,
    className: variant === "destructive" ? "bg-destructive text-destructive-foreground" : undefined,
    ...props,
  });
}

export { Toaster, type ToastT as Toast };
export type ToastActionElement = React.ReactElement<
  unknown,
  string | React.JSXElementConstructor<any>
>;

export const useToast = () => {
  return {
    toast,
    dismiss: sonnerToast.dismiss,
    error: (message: string, options?: Omit<ToasterProps, "message">) => 
      sonnerToast.error(message, options),
    success: (message: string, options?: Omit<ToasterProps, "message">) => 
      sonnerToast.success(message, options),
    warning: (message: string, options?: Omit<ToasterProps, "message">) => 
      sonnerToast.warning(message, options),
    info: (message: string, options?: Omit<ToasterProps, "message">) => 
      sonnerToast.info(message, options),
    promise: sonnerToast.promise,
    custom: sonnerToast.custom,
  };
};
